module.exports = __webpack_public_path__ + "img/236-republic-of-macedonia.5632011e.svg";